import { InitPageContainer } from './init-page.container';

export const InitPage = () => <InitPageContainer />;
